import React from 'react';
import tpl from '../templates/bolt';
import {apiback} from '../../../../config';
import CreditCardsModel from '../../models/creditCards.m';
import BaseNewCardView from '../../views/BaseNewCardView';

export default class extends BaseNewCardView {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            model: {},
            tab: 'how-to'
        };
    }

    componentDidMount() {
        super.componentDidMount();

        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new CreditCardsModel(json.data['green_card'])
                })
            );
    }

    static displayName = 'BoltCard.Views.Main';
}
